import { ReactNode, useMemo } from 'react';
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "next-themes";
import { SearchProvider } from "@/contexts/SearchContext";
import { QueryProvider } from "./QueryProvider";

interface OptimizedProvidersProps {
  children: ReactNode;
}

// Memoized providers to prevent unnecessary re-renders
export const OptimizedProviders = ({ children }: OptimizedProvidersProps) => {
  // Memoize theme provider props to prevent re-creation
  const themeProviderProps = useMemo(() => ({
    attribute: "class" as const,
    defaultTheme: "system" as const,
    enableSystem: true
  }), []);

  return (
    <ThemeProvider {...themeProviderProps}>
      <QueryProvider>
        <SearchProvider>
          <BrowserRouter>
            {children}
          </BrowserRouter>
        </SearchProvider>
      </QueryProvider>
    </ThemeProvider>
  );
};